import { Collection, Controller, util } from '@glu/core';

const FilterProcessor = Controller.extend({
  constructor: function (opts) {
    Controller.prototype.constructor.call(this, opts);
    this.input = opts.inputCollection;
    this.output = opts.outputCollection;

    this.filters = new Collection();
    this.filterMethod = opts.filterMethod;
    this.columns = opts.columns;
    this.stateModel = opts.stateModel;

    this.listenTo(this.input, 'change reset remove add sync', util.debounce(util.bind(this.handleInputChange, this)));
    this.listenTo(this.filters, 'change reset remove add', this.handleFilterChange);
  },

  handleInputChange(e) {
    if (this.isClosed) {
      return;
    }

    this.process(false);
    return e;
  },

  handleFilterChange(e) {
    this.process(true);
    this.input.trigger('grid:filter:change', this);
    return e;
  },

  /**
   * Add the specified filter to the list of active filters.
   *
   * @param filter
   */
  addFilter(filter) {
    this.filters.push(filter);
    this.trigger('add', filter, this.filters);
    this.process();
  },

  /**
   * Remove any filters associated with the specified field.
   *
   * @param field
   */
  removeFilters(field) {
    const filters = this.filters.where({
      field
    });

    if (filters.length > 0) {
      util.each(filters, filter => {
        this.filters.remove(filter, {
          silent: true
        });
      });

      this.process(true);
    }

    // Regardless of whether or not a filter was removed, trigger a refresh event so
    // listeners have a chance to react.
    this.refresh();
  },

  /**
   * Fire a refresh event for so listeners have a chance to react and possibly re-render.
   */
  refresh() {
    this.filters.trigger('refresh');
  },

  /**
   * Remove all filters.
   */
  clear() {
    this.filters.reset([]);
    this.input.trigger('grid:filters:clear', this);
  },

  process(filterChange) {
    if (this.stateModel !== null) {
      this.stateModel.setFilters(this.filters.toJSON());
    }

    if (typeof this.filterMethod === 'function') {
      if (filterChange) {
        // columns needed for those cases where you need to know type of a separate grid column
        // which you can specify in grid schema
        return this.filterMethod(this.filters, (input) => {
          this.input.reset(input);
          this.output.reset(input);
        }, this.columns);
      }

      return this.output.reset(this.input.models);
    }

    this.processLocal(filterChange);
  },

  processLocal() {
    if (this.filters.length === 0) {
      this.output.reset(this.input.models);
    } else {
      let result = this.input;
      this.filters.each((filter) => {
        result = result.filter(filter.get('filter'));
      });
      this.output.reset(result);
    }

    // Broadcast a filter event.  Make sure it's the last thing we do.
    this.appBus.trigger('grid:filter', this);
  }
});

export default FilterProcessor;
